var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('result-display',{attrs:{"current-lang":_vm.$route.params.currentLang,"current-pattern":_vm.$route.params.currentPattern,"current-image-file-path":_vm.$route.params.currentImageFilePath,"target-url":_vm.$route.params.targetUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }